export const sso = {
  title: `We couldn't log you in...`,
  text: `We encountered an error. We apologize for the inconvenience. Please try logging in again via your Vancity Visa card page`,
  vancityButton: 'Try again',
  vancityURL: 'https://creditcards.vancity.com/?product=VANCITY',
};
